
const BooksHero = () => {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#1B3A52] to-[#2a5270]">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="relative max-w-5xl mx-auto text-center">
        <p className="text-xs text-[#D4AF37] uppercase tracking-wider mb-5">(Published Works)</p>
        <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight">
          Books That Inspire Faith
        </h1>
        <p className="text-lg md:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto">
          Explore a collection of biblically-grounded books designed to deepen your relationship with God, strengthen your faith, and guide you through life's journey.
        </p>
      </div>
    </section>
  );
};

export default BooksHero;
